// extracted by mini-css-extract-plugin
export default {"item":"GetInTouchBox_item__Y8A8S","icon":"GetInTouchBox_icon__IIZkB"};